import { MARQUEE_ITEMS } from "@/data/content";

export default function Marquee() {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-charcoal-900 text-parchment/80 py-5 overflow-hidden select-none"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif italic text-xl sm:text-2xl px-8 whitespace-nowrap">{item}</span>
                <span className="w-1.5 h-1.5 rounded-full bg-copper-500" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
